import ToastPlugin from "vue-toast-notification";
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import 'vue-toast-notification/dist/theme-sugar.css';

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.component('ExColorPicker', ColorPicker);
    nuxtApp.vueApp.use(ToastPlugin);
});